import { Card, CardContent } from "./ui/card"
import { Badge } from "./ui/badge"

export function AwardCard({ icon, title, description, year }) {
  return (
    <Card className="transition-all hover:shadow-md hover:translate-y-[-5px] duration-300">
      <CardContent className="p-6 text-center">
        <div className="flex justify-center mb-4">
          <div className="p-3 rounded-full bg-gray-100 inline-flex">{icon}</div>
        </div>
        <h3 className="mb-1 text-lg font-bold">{title}</h3>
        <p className="mb-2 text-sm text-muted-foreground">{description}</p>
        <Badge variant="outline" className="mt-2">
          {year}
        </Badge>
      </CardContent>
    </Card>
  )
}